module.exports = __webpack_public_path__ + "index_pc/img/xian_2.7c2103c3.jpg";